import React, {ChangeEvent, useEffect, useRef, useState} from "react";
import moment from 'moment';
import {SelectorList} from "./SelectorList";
import {Cancel, CheckCircle} from "@material-ui/icons";
import {Button, Checkbox, FormControlLabel, InputAdornment, makeStyles, TextField, Typography} from "@material-ui/core";
import {IRepeatBookingListProps} from "./types";
import debounce from 'lodash/debounce';
import {renderIf} from "external-services/react-utils-service";
import style from './style.module.scss';
import TableSeater from "shared-components/table-seater/alt-version";
import { isEmpty } from "lodash-es";
import RecurringTableSeaterService from "shared-services/recurring-booking-service/RecurringTableSeater.service";
import {
  IRecurringBookingDetail,
  IRecurringBookingSubset, ISectionDetails, ITableSeaterRecurringProps,
  IWeeklyScheduleSubset
} from "shared-services/recurring-booking-service/type";
import {SECTION_ANY_ID, SECTION_ANY_NAME} from "shared-types/SharedTypes";
import classNames from "classnames";
import {
  getServicesFromSchedule, getWeeklyServiceOptions
} from "./helper";
import { IServiceListItem } from 'app/bookings/new/types/newBooking.types';
import RecurringBookingService from 'shared-services/recurring-booking-service';




export const RepeatBookingList = ({
  bookingIndex, bookingDetail, serviceListOptions, tableSeaterRecurringParams, classPrefix,
  onBookingSelection, onBookingChange, weeklySchedule
}: IRepeatBookingListProps) => {
  const useStyle = makeStyles({
    bookingList: {
      width: 1000,
      display: 'flex',
      margin: '10px 0px',
      justifyContent: 'space-between'
    },
    bookingDate: {
      [`& .${classPrefix}-MuiInputBase-root`]: {
        margin: '-3px 0px 0px 5px',
        paddingBottom: '7px'
      },
      [`& .${classPrefix}-MuiInputBase-input`]: {
        width: 150,
        padding: '10px 0 3px'
      }
    },
    paxCount: {
      [`& .${classPrefix}-MuiInput-formControl`]: {
        marginTop: 14,
      },
      [`& .${classPrefix}-MuiInputBase-input`]: {
        height: 8,
        width: 50,
        padding: '6px 0px'
      },
    },
    bookingCheckBox: {
      [`& .${classPrefix}-MuiFormControlLabel-root`]: {
        marginRight: 0
      }
    },
    serviceDropDown: {
      [`& .${classPrefix}-MuiFormControl-root`]: {
        marginTop: 2
      }
    },
    serviceMenu: {
      display: 'flex',
      flexDirection: 'column'
    },
    validityIcon: {
      marginTop: 5
    },
    adornmentDateStyle: {
      margin: '7px 2px 0 0',
    },
    tableStyle: {
      marginTop: -5,

    },
    noTableStyle: {
      marginTop: -8
    },
    noTableButtonStyle: {
      marginTop: 10
    }
  });

  const classes = useStyle();
  const {booking, isValid, reason} = bookingDetail;
  const initialRender = useRef<boolean>(true);
  const initialTableRender = useRef<boolean>(true);
  const duration = useRef<HTMLInputElement>(null);
  const numberOfPax = useRef<HTMLInputElement>(null);
  const [isBookingValid, setBookingValidity] = useState<boolean>(isValid);
  const [errorMessage, setErrorMessage] = useState<string>(reason);
  const [selectedTableIds, setTableId] = useState<string[]>(booking.tableIds);
  const [bookingTime, setBookingTime] = useState<string>(moment(booking.time).format('HH:mm'));
  const [bookingDateTime, setBookingDateTime] = useState<string>(moment(booking.time).format('DD-MM-YYYYTHH:mm'));
  const [tableSeaterProps, setTableSeaterProps] = useState<ITableSeaterRecurringProps>(tableSeaterRecurringParams.props);
  const [openTable, setOpenTable] = useState<boolean>(false);
  const [tableApiCalled, setTableApiCalled] = useState<boolean>(false);
  const [hideButton, setHideButton] = useState<boolean>(false);
  const serviceListOptionsVal = getServiceListValues();
  let serviceId;
  if (!isEmpty(weeklySchedule)) {
    serviceId = serviceListOptionsVal.selectedOption;
  } else {
    serviceId = booking.serviceId;
  }
  const [selectedServiceId, setSelectedServiceId] = useState<string>(serviceId);
  useEffect(() => {
    duration.current.value = booking.duration?.toString();
    numberOfPax.current.value = booking.numOfPeople?.toString();

    if (!isBookingValid && bookingIndex > 0) {
      callTableSeaterApiForEveryBooking(booking).then((r) => {
        setTableApiCalled(true);
      });
    }
  }, []);
  function getDaySchedule():IWeeklyScheduleSubset {
    const dayName: string = moment(booking.time).format('dddd');
    return weeklySchedule.find((schedule: IWeeklyScheduleSubset)=> schedule.dayName === dayName);
  }
  function getServiceListValues() {
    let _servicesListOptions = serviceListOptions;
    if (!isEmpty(weeklySchedule)) {
      const daySchedule: IWeeklyScheduleSubset = getDaySchedule();
      const serviceList: IServiceListItem[] = getServicesFromSchedule(daySchedule)
      _servicesListOptions = getWeeklyServiceOptions(booking.serviceName, serviceList);
    }
    return _servicesListOptions
  }

  const callTableSeaterApiForEveryBooking = async (bookingInfo: IRecurringBookingSubset) => {
    if (!isEmpty(weeklySchedule)) {
      const daySchedule: IWeeklyScheduleSubset = getDaySchedule();
      tableSeaterRecurringParams.props = await RecurringTableSeaterService.getTableSeaterInfo(tableSeaterRecurringParams.props, serviceListOptionsVal.selectedOption, bookingInfo.time, bookingInfo.numOfPeople, null, daySchedule.isVenueOpen);
    } else {
      tableSeaterRecurringParams.props = await RecurringTableSeaterService.getTableSeaterInfo(tableSeaterRecurringParams.props, bookingInfo.serviceId, bookingInfo.time, bookingInfo.numOfPeople);
    }
    tableSeaterRecurringParams.props.booking = bookingInfo;
    setTableSeaterProps(tableSeaterRecurringParams.props);
    bookingDetail.booking = updatingBookingObject(bookingDetail.booking);
  }

  useEffect(() => {
    bookingDetail.booking = updatingBookingObject(bookingDetail.booking)
    tableSeaterRecurringParams.props.booking = bookingDetail.booking;
    setTableSeaterProps({...tableSeaterRecurringParams.props});
  }, [bookingDetail]);

  useEffect(() => {
    if (!initialRender.current) {
      validateRecurringBooking();
    } else {
      initialRender.current = false;
    }
  }, [bookingDateTime, selectedServiceId]);

  useEffect(() => {
    if (!initialTableRender.current) {
      // Run only validation on table change - no need to call table picker
      recurringBookingValidation(selectedTableIds).then(() => {
        tableSeaterRecurringParams.props.preselectedTableIds = selectedTableIds;
        setTableSeaterProps({...tableSeaterRecurringParams.props});
      });
    } else {
      initialTableRender.current = false;
    }
  }, [selectedTableIds]);

  const validateRecurringBooking = debounce(async () => {
    const time = moment(bookingDateTime, 'DD-MM-YYYYTHH:mm').format('YYYY-MM-DDTHH:mm:ss')
    if (numberOfPax.current ) {
      tableSeaterRecurringParams.props = await RecurringTableSeaterService.getTableSeaterInfo(tableSeaterProps, selectedServiceId, time, parseInt(numberOfPax.current.value));
    } else {
      return
    }
    setTableSeaterProps({...tableSeaterRecurringParams.props});
    setTableApiCalled(true);
    await recurringBookingValidation(tableSeaterRecurringParams.props.preselectedTableIds, tableSeaterRecurringParams.props);

  }, 500)

  const recurringBookingValidation = async (selectedTableIds: string[], tableSeaterPropsVal = tableSeaterRecurringParams.props) => {
    const sectionDetails: ISectionDetails[] = RecurringBookingService.getSectionInfo(tableSeaterPropsVal, selectedTableIds);
    const bookingValidationRequest: IRecurringBookingSubset = {
      tableIds: selectedTableIds,
      serviceId: selectedServiceId,
      sectionId: !isEmpty(sectionDetails) ? sectionDetails[0].id : SECTION_ANY_ID,
      sectionName: !isEmpty(sectionDetails) ? sectionDetails[0].name : SECTION_ANY_NAME,
      time: moment(bookingDateTime, 'DD-MM-YYYYTHH:mm').format('YYYY-MM-DDTHH:mm:ss'),
      duration: duration.current.value,
      numOfPeople: parseInt(numberOfPax.current.value)
    }
    const response: IRecurringBookingDetail[] = await RecurringBookingService.ValidateRecurringBooking([bookingValidationRequest]);
    if (response.length) {
      const isBookingValid = response[0].isValid;
      setErrorMessage(response[0].reason);
      setBookingValidity(isBookingValid);
      response[0].booking = updatingBookingObject(response[0].booking)
      onBookingChange(bookingIndex, isBookingValid, response[0].booking);
    }
  }

  const updatingBookingObject = (booking: IRecurringBookingSubset): IRecurringBookingSubset => {
    booking.serviceName = serviceListOptionsVal.listOfOptions.find(s => s.value === selectedServiceId).name; // find the service name of the selected service
    booking.index = bookingIndex;
    return booking;
  }

  const convertTimeToDateTime = (time: string, bookingTime: string) => {
    const date: string = moment(bookingTime, 'YYYY-MM-DDTHH:mm').format('DD-MM-YYYY');
    const isoStamp: string = `${date}T${time}`;
    const dateTime: string = moment(isoStamp, 'DD-MM-YYYYTHH:mm').format('DD-MM-YYYYTHH:mm');
    setBookingTime(time);
    setBookingDateTime(dateTime);
  }

  const renderInput = (): any => (
    <span className={classes.adornmentDateStyle}>{moment(booking.time).format('DD/MM/YYYY')}</span>
  );

  return (
    <>
      {renderIf(!isEmpty(bookingDetail), () => (
        <div>
          <div className={classes.bookingList}>
            <div className={classes.bookingCheckBox}>
              <FormControlLabel
                label=""
                control={
                  <Checkbox
                    color="primary"
                    defaultChecked={bookingDetail.hasSelected}
                    disabled={bookingIndex === 0}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => onBookingSelection(bookingIndex, e.target.checked)}/> as any
                }/>
            </div>
            <div className={classes.paxCount}>
              <TextField disabled={bookingIndex === 0} label="People" type="number" inputRef={numberOfPax}
                         InputLabelProps={{shrink: true}}
                         onChange={validateRecurringBooking}/>
            </div>
            <div className={classes.paxCount}>
              <TextField disabled={bookingIndex === 0} label="Duration" type="number" inputRef={duration}
                         InputLabelProps={{shrink: true}}
                         onChange={validateRecurringBooking}/>
            </div>
            <SelectorList
              classPrefix={classPrefix}
              disabled={bookingIndex === 0}
              selectedOption={selectedServiceId}
              onSelectedOptionChange={setSelectedServiceId}
              listOfOptions={serviceListOptionsVal.listOfOptions}/>

            <div
              className={classNames({
              [classes.tableStyle]: !isEmpty(tableSeaterProps.tableSelectionList),
              [classes.noTableStyle]: isEmpty(tableSeaterProps.tableSelectionList),
            })}>
              <Button variant="text" className={classNames({
                [style.invisibleButton]: true,
                [style.hideButton]: bookingIndex > 0 ? hideButton : true,
                [classes.noTableButtonStyle]: isEmpty(tableSeaterProps.tableSelectionList)
              })}
                      onClick={() => {
                        // we have to make an api call to get the table seater information - If there was an error on the booking we have already made a call so no need to do it again
                        if (!tableApiCalled) {
                          callTableSeaterApiForEveryBooking(booking).then((r) => {
                            setTableApiCalled(true);
                            setOpenTable(true);
                            setHideButton(true);
                          })
                        } else {
                          if (!isEmpty(tableSeaterProps.tableSelectionList)) {
                            setOpenTable(true);
                          }
                        }
                      }}
              />
              <TableSeater {...tableSeaterProps} {...tableSeaterRecurringParams.handlers} handleSelectedChanged={(ids) => setTableId(ids)} isTypeRecurring={true} isDisabled={bookingIndex === 0}
                           isDropdownOpen={openTable}
                           returnToParent={() => {
                             setOpenTable(false);
                             setHideButton(false);
                           }}/>

            </div>
            <div className={classes.bookingDate}>
              <TextField
                disabled={bookingIndex === 0}
                variant="standard"
                type="time"
                value={bookingTime}
                InputLabelProps={{shrink: true}}
                onChange={date => convertTimeToDateTime(date.target.value, booking.time)}
                inputProps={{
                  step: '300', // 5 min
                }}
                InputProps={{
                  startAdornment: <InputAdornment component={renderInput} position="start"/>,
                }}
              />
            </div>
            <div className={classes.validityIcon}>
              {
                bookingIndex > 0 && !isBookingValid ? <Cancel className={style.fillColorError}/> :
                  <CheckCircle className={style.fillColorSuccess}/>
              }
            </div>
          </div>
          {/*We wont show validation messages for the 1st row as it is the original booking*/}
          {renderIf(bookingIndex > 0 && !isBookingValid, () => (
            <Typography className={style.errorMessage} data-testid="error-recurring">{errorMessage}</Typography>
          ))}
        </div>
      ))}
    </>
  )
}
